.app-layout {
  --app-nav-width: 96px;

  @apply grid;
  grid-template:
    " main " 1fr
    / 1fr;

  @screen mmd {
    grid-template:
      " nav                  main . " 1fr
      / var(--app-nav-width) 1fr 16px;
  }
}

.app-layout-expanded {
  --app-nav-shrinked-width: 96px;
  --app-nav-width: 208px;

  @apply grid;
  grid-template:
    " main " 1fr
    / 1fr;

  @screen mmd {
    grid-template:
      " nav                  main . " 1fr
      / var(--app-nav-width) 1fr 16px;
  }
}
